module.exports = require("@swa-ui/design-tokens/src/generated/platforms/scss/vacations-light-inverse.module.scss");